// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__LGXWZ","checkmark":"Checkbox_checkmark__edsIb"};